var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({attrs:{"label":_vm.label,"rules":_vm.rules,"single-line":"","hide-spin-buttons":"","type":"number"}},'v-text-field',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }